"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pandeAuthorizeReducer = exports.pandeAuthorizeActions = exports.TYPES = exports.INIT_STATE_AUTHORIZE = exports.INIT_ICON_COLUMN = exports.INIT_AUTHORIZE = exports.CONTENTS = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'pandeAuthorize';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  GO_MAIN: PREFIX + 'GoMain',
  GO_UPDATE: PREFIX + 'GoUpdate',
  GO_RESULT: PREFIX + 'GoResult',
  SET_CONTENT: PREFIX + 'SetContent',
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  CHANGE_PAGE: PREFIX + 'ChangeCurrentPage',
  CHANGE_CURRENT_PAGE: PREFIX + 'ChangeCurrentPage',
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  RESET_PAGING: PREFIX + 'ResetPaging',
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  INITIALIZE_CONDITION: PREFIX + 'InitializeCondtion',
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  SAVE_SEARCH_CONDITIONS: PREFIX + 'SaveSearchConditions',
  APPLY_SHARE_CONDITION: PREFIX + 'ApplyShareCondtion',
  MODIFIED: PREFIX + 'AllCleared',
  CLEAR: PREFIX + 'Clear',
  SET_ENTRY: PREFIX + 'SetEntry',
  APPEND_RECORD: PREFIX + 'AppendRecord',
  MODIFY_RECORD: PREFIX + 'ModifyRecord',
  DELETE_RECORD: PREFIX + 'DeleteRecord'
};
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  UPDATE: 'update',
  RESULT: 'result'
};
const INIT_KAISHA_SOSHIKI = {
  kaishaCd: '',
  soshikiCd: '',
  label: ''
};
const INIT_STATE_AUTHORIZE = exports.INIT_STATE_AUTHORIZE = {
  authCd: '',
  kaisha: {
    permitKaishaCd: ''
  },
  kaishaSoshiki: {
    permitKaishaCd: '',
    permitSoshikiCd: '',
    label: ''
  },
  site: {
    permitSiteNo: '',
    siteBuildingNm: ''
  }
};
const INIT_ICON_COLUMN = exports.INIT_ICON_COLUMN = {
  dataKey: '',
  label: '',
  width: 42,
  minWidth: 42,
  maxWidth: 42,
  headerStyle: {
    textAlign: 'center',
    paddingLeft: 0
  },
  cellStyle: {
    textAlign: 'center',
    paddingLeft: 0
  }
};
const INIT_AUTHORIZE = exports.INIT_AUTHORIZE = {
  key: null,
  isNew: true,
  changeable: true,
  authCd: '',
  permitKaisha: {
    kaishaCd: '',
    label: ''
  },
  permitKaishaSoshiki: {
    kaishaCd: '',
    soshikiCd: '',
    label: ''
  },
  permitSite: {
    siteNo: '',
    tdfkCd: '',
    kaishaCd: '',
    label: ''
  },
  permitTdfk: {
    kaishaCd: '',
    tdfkCd: '',
    label: ''
  },
  mailYohi: true
};
const INIT_STATE = {
  dispContent: CONTENTS.MAIN,
  conditionInitialized: false,
  doSearch: false,
  kaishaCd: '',
  shainId: '',
  searchConditions: {
    seimei: '',
    pandeAuthCd: '',
    jobClassCd: '',
    kaishaSoshiki: _objectSpread({}, INIT_KAISHA_SOSHIKI)
  },
  saveConditions: null,
  searchResult: [],
  scrollTop: {
    index: 0,
    scrollY: 0,
    noSticky: false
  },
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  showAll: false,
  entries: null
};
const pandeAuthorizeActions = exports.pandeAuthorizeActions = (0, _reduxActions.createActions)({
  [TYPES.GO_MAIN]: function () {
    return {
      updated: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_UPDATE]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.INITIALIZE_CONDITION]: function () {
    return {
      kaishaSoshiki: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.APPLY_SHARE_CONDITION]: function () {
    return {
      shareCondition: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CURRENT_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.APPEND_RECORD]: function () {
    return {
      record: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.MODIFY_RECORD]: function () {
    return {
      record: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.DELETE_RECORD]: function () {
    return {
      record: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.SAVE_SEARCH_CONDITIONS, TYPES.RESET_PAGING, TYPES.MODIFIED, TYPES.GO_RESULT, TYPES.CLEAR);
const pandeAuthorizeReducer = exports.pandeAuthorizeReducer = (0, _reduxActions.handleActions)({
  [TYPES.INITIALIZE_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      kaishaSoshiki: _objectSpread({}, action.payload.kaishaSoshiki)
    }),
    conditionInitialized: true
  }),
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.SAVE_SEARCH_CONDITIONS]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    saveConditions: _objectSpread({}, state.searchConditions)
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.searchResult,
    doSearch: false
  }),
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    const searchResult = JSON.parse(JSON.stringify(state.searchResult)).map(e => e);
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult,
      showAll: action.payload.showAll
    });
  },
  [TYPES.CHANGE_CURRENT_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: 0,
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: action.payload.scrollTop
  }),
  [TYPES.RESET_PAGING]: state => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.GO_MAIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.MAIN,
    entries: null,
    doSearch: action.payload.updated
  }),
  [TYPES.GO_UPDATE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.UPDATE,
    entries: _objectSpread({}, action.payload.entries)
  }),
  [TYPES.GO_RESULT]: state => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.RESULT
  }),
  [TYPES.MODIFIED]: state => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.MAIN,
    doSearch: true,
    entries: {}
  }),
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE),
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.SET_ENTRY]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    entries: _objectSpread(_objectSpread({}, state.entries), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.APPEND_RECORD]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        authorizeList: state.entries.authorizeList.concat([action.payload.record])
      })
    });
  },
  [TYPES.MODIFY_RECORD]: (state, action) => {
    let records = state.entries.authorizeList.slice();
    const idx = records.findIndex(r => r.key === action.payload.record.key);
    records.splice(idx, 1, _objectSpread({}, action.payload.record));
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        authorizeList: records
      })
    });
  },
  [TYPES.DELETE_RECORD]: (state, action) => {
    let records = state.entries.authorizeList.slice();
    const idx = records.findIndex(r => r.key === action.payload.record.key);
    records.splice(idx, 1);
    return _objectSpread(_objectSpread({}, state), {}, {
      editing: true,
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        authorizeList: records
      })
    });
  }
}, INIT_STATE);